<button mat-icon-button type="button" [matMenuTriggerFor]="menu" title="Configurer les colonnes">
  <mat-icon style="color: var(--primary-color);">settings</mat-icon>
</button>
<mat-menu #menu="matMenu">
  <div style="padding: 8px 16px; display: flex; flex-direction: column; gap: 8px;" (click)="$event.stopPropagation()">
    <span style="font-weight: bold; margin-bottom: 4px; font-size: 13px;">Colonnes visibles</span>
    <mat-checkbox 
      *ngFor="let col of allColumns"
      [checked]="isColumnVisible(col.id)"
      (change)="toggleColumn(col.id, $event)">
      {{ col.name }}
    </mat-checkbox>
  </div>
</mat-menu>
